import { FC } from 'react';

const ArrowBullet: FC<{ className?: string; isMobile: boolean }> = ({
  className,
  isMobile = false,
}) => {
  return (
    <div>
      {isMobile ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="55"
          height="16"
          viewBox="0 0 55 16"
          fill="none"
          className={className}
        >
          <path
            d="M54.7071 8.70711C55.0976 8.31658 55.0976 7.68342 54.7071 7.29289L48.3432 0.928932C47.9526 0.538408 47.3195 0.538408 46.9289 0.928932C46.5384 1.31946 46.5384 1.95262 46.9289 2.34315L52.5858 8L46.9289 13.6569C46.5384 14.0474 46.5384 14.6805 46.9289 15.0711C47.3195 15.4616 47.9526 15.4616 48.3432 15.0711L54.7071 8.70711ZM0 9H54V7H0V9Z"
            fill="#BAA57E"
          />
        </svg>
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="89"
          height="16"
          viewBox="0 0 89 16"
          fill="none"
          className={className}
        >
          <path
            d="M88.7071 8.70711C89.0976 8.31658 89.0976 7.68342 88.7071 7.29289L82.3431 0.928932C81.9526 0.538408 81.3195 0.538408 80.9289 0.928932C80.5384 1.31946 80.5384 1.95262 80.9289 2.34315L86.5858 8L80.9289 13.6569C80.5384 14.0474 80.5384 14.6805 80.9289 15.0711C81.3195 15.4616 81.9526 15.4616 82.3431 15.0711L88.7071 8.70711ZM0 9H88V7H0V9Z"
            fill="#BAA57E"
          />
        </svg>
      )}
    </div>
  );
};

export default ArrowBullet;
